﻿export class StringResult {
    constructor(public value: string) {
    }
}